// @wf-will-never-add-flow-to-this-file

import {emotionStyled} from '@packages/utilities/styled';
import {Textarea} from '@packages/systems/spring';
import {brandedFontFamily} from '../../constants';

export const BrandedTextareaView = emotionStyled(Textarea)({
  fontFamily: brandedFontFamily,
  textarea: {fontSize: '14px'},
});
